<template>
    <div class="composer-menu">
        <div class="row">
            <div class="col-6" 
                v-for="{component, definition} in brickDefinitions"
                :key="definition.type"
            >
                <component 
                    :is="component"
                    :displayName="definition.displayName"
                    :icon="definition.icon"
                    :brick-type="definition.type"
                        
                    :class="[definition.name, canWrite ? 'addable' : '']"
                    class="composable"

                    @click.native="addBrick(definition)"
                    
                    :draggable="canWrite"
                    @dragstart.native="dragStart($event, definition)"
                />
            </div>
        </div>
    </div>
</template>

<script>
    import journeyTypes from "@modules/JourneyBuilder/journeyTypes";
    import brickTypes from "@modules/JourneyBuilder/Bricks/brick-types";
    import brickDisplayFormats from '@modules/JourneyBuilder/Bricks/brick-display-formats';
    import {brickDefinitionsArray} from '@modules/JourneyBuilder/Bricks/brick-definitions';
    import ToolboxDragAction from "./toolbox-drag-action";

    import permissionsMixin from '@modules/JourneyBuilder/Mixins/journey-permissions';
    
    import ComposableSquareBrick from "./MenuComposableSquareBrick";
    import ComposableOctagonBrick from "./MenuComposableOctagonBrick";
    import {FLAGS} from "@modules/JourneyBuilder/constants";
        
    export default {
        name: 'menu-brick-toolbox',
        mixins: [permissionsMixin],
        computed: {
            brickDefinitions() {
                return brickDefinitionsArray.filter(brickDefinition => this.canDisplayBrickInMenu(brickDefinition)).map(brickDefinition => {
                    const component = brickDefinition.displayFormat === brickDisplayFormats.octagon ?
                        ComposableOctagonBrick :
                        ComposableSquareBrick;
                    
                    return {
                        component: component,
                        definition: brickDefinition
                    }
                });
            }
        },
        methods: {
            addBrick(definition){
                if(!this.canWrite){
                    return;
                }
                
                this.$emit('add-brick', definition);
            },
            dragStart(event, definition){
                const action = new ToolboxDragAction(ToolboxDragAction.TYPE_BRICK, definition);
                
                event.dataTransfer.dropEffect = 'none';
                action.writeToEvent(event);
            },
            /**
             * @param {JourneyBrick} brickDefinition
             * @returns {Boolean}
             */
            canDisplayBrickInMenu(brickDefinition) {
                //DPN-3098 - Audience filter bricks are to be phased out in favor of checkpoints
                //the first step is not displaying the brick type in our menu anymore
                if(brickDefinition.type === brickTypes.audienceFilter) {
                    return false;
                }
                
                //Umbrella journeys only support journey bricks
                if(this.journeyType === journeyTypes.umbrella) {
                    return brickDefinition.type === brickTypes.journey;
                }
                
                return true;
            }
        },
        props: {
            journeyType:0
        }
    }
</script>